import { render, staticRenderFns } from "./BillingOrder.vue?vue&type=template&id=fb8cbbfe"
import script from "./BillingOrder.vue?vue&type=script&lang=js"
export * from "./BillingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports